import getConfig from 'next/config';
import { useEffect, useState } from 'react';

export const useNextAppConfig = () => {
  const [config, setConfig] = useState<Record<string, unknown> | null>(null);
  useEffect(() => {
    const { publicRuntimeConfig } = getConfig();
    setConfig(publicRuntimeConfig);
  }, []);
  return config;
};
